import React from "react";
import { Container, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { NAP } from "../seo/site";

/** Full-height spinner used while a page's data loads or a lazy route chunk downloads. */
export const PageSpinner = ({ label = "Loading…" }) => (
  <div style={{ minHeight: "calc(100vh - var(--nav-height))", display: "flex", alignItems: "center", justifyContent: "center" }}>
    <Spinner animation="border" role="status" style={{ color: "var(--brand-orange)", width: 48, height: 48 }}>
      <span className="sr-only">{label}</span>
    </Spinner>
  </div>
);

/** Friendly failure state with a way forward, instead of a spinner that never ends. */
export const PageError = ({ title = "We couldn't load this page", children }) => (
  <section className="notfound" role="alert">
    <Container>
      <h1>{title}</h1>
      <p>
        {children || (
          <>
            Our tour information service didn't respond. Please refresh in a moment, or call{" "}
            <a href={NAP.telephoneHref}>{NAP.telephoneDisplay}</a> and we'll help you book.
          </>
        )}
      </p>
      <div className="notfound__links">
        <Link to="/" className="btn-brand">See All Tours</Link>
        <Link to="/contact-us" className="btn-outline-dark-custom">Contact Us</Link>
      </div>
    </Container>
  </section>
);
